/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import _isNil from 'lodash/isNil';
import { parseNumber } from 'volta/utils/math-utils';

import { action } from '@ember/object';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';

import type { ICustomFieldDefinition } from 'volta/models/types/custom-field-definition';

export interface IInputFilterDefinitionArgs {
  definition?: ICustomFieldDefinition;
  inputType?: 'text' | 'richtext' | 'number' | 'date' | 'array';
}

export default class FiltersInputFilterComponent extends Component<
  FilterComponentSignature<IInputFilterDefinitionArgs>
> {
  get min() {
    return parseNumber(this.leftValue);
  }

  get max() {
    return parseNumber(this.rightValue);
  }

  get values() {
    return this.args.values ?? [];
  }

  get inputType() {
    return this.args.componentArgs?.inputType ?? 'text';
  }

  get leftValue() {
    return this.value;
  }

  get value() {
    return this.values?.length ? this.values[0] : undefined;
  }

  get rightValue() {
    return this.values?.length === 2 ? this.values[1] : undefined;
  }

  get isFaulty() {
    if (_isNil(this.leftValue) || _isNil(this.rightValue) || this.inputType !== 'number') {
      return false;
    }
    return this.leftValue > this.rightValue;
  }

  get showCustomFieldValueSelect() {
    return (
      this.args.definition.customFieldDefinition &&
      (this.inputType === 'text' || this.inputType === 'array')
    );
  }

  @action
  valueDidChange(newValue?: string | number) {
    this.args.onChange?.(isPresent(newValue) ? [newValue as string] : []);
  }

  @action
  valuesDidChange(options: string[]) {
    this.args.onChange?.(options);
  }

  @action
  valueLeftDidChange(leftValue?: string | number) {
    const { values = [] } = this;
    if (isPresent(leftValue)) {
      values[0] = leftValue as string;
      if (values.length === 2) {
        this.args.onChange?.(values);
      }
    }
  }

  @action
  valueRightDidChange(rightValue?: string | number) {
    const { values = [] } = this;
    if (isPresent(rightValue)) {
      values[1] = rightValue as string;
      if (values.length === 2) {
        this.args.onChange?.(values);
      }
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::InputFilter': typeof FiltersInputFilterComponent;
    'filters/input-filter': typeof FiltersInputFilterComponent;
  }
}
